const rootActionPath = 'core/InstoreMultiLinkModal';

export const INSTORE_MULTI_LINK_MODAL_TRIGGER = `${rootActionPath}/TRIGGER`;
export const INSTORE_MULTI_LINK_MODAL_CLEAR = `${rootActionPath}/CLEAR`;
